import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { Text } from '@components/text';

import { Modal, useModal } from 'features/modals';

type SettingsModalProps = {
  description?: string;
  onSave(): void;
  onSuccess?(): void;
  saveDisabled: boolean;
  title: string;
};

export const SettingsModal: React.FC<SettingsModalProps> = ({
  children,
  description,
  saveDisabled,
  onSave,
  title,
}) => {
  const { hideModal } = useModal();
  return (
    <Modal>
      <Modal.Header text={title} />
      {description && <Text color="purple80" font="regular14" text={description} />}
      {children}
      <CancelSaveButtons
        alwaysShow
        onCancel={hideModal}
        isDisabled={saveDisabled}
        onSave={onSave}
        onSuccess={hideModal}
      />
    </Modal>
  );
};
